import { Avatar, Typography } from '@mui/material';

type WarningsBadgeProps = {
  color: string;
  count: number;
};

export const WarningsBadge = ({ color, count }: WarningsBadgeProps) => (
  <Avatar sx={{ bgcolor: color, width: 16, height: 16 }} variant={'circular'}>
    <Typography variant='alarmBadge'>{count}</Typography>
  </Avatar>
);

export default WarningsBadge;
